import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const useReCaptcha = () => {
  const reCaptchaRef = useRef();
    const isLocal = () =>
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const executeReCaptcha = async () => {
    if (isLocal()) {
      return "NO-TOKEN";
    }
    if (!reCaptchaRef.current) {
      return null;
    }
    try {
      const token = await reCaptchaRef.current.executeAsync();
      reCaptchaRef.current.reset();
      return token;
    } catch (error) {
      console.error("Error executing ReCAPTCHA:", error);
      return null;
    }
  };

  const ReCaptchaComponent = () => (
    <ReCAPTCHA
      ref={reCaptchaRef}
      sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
      size="invisible"
      style={{ visibility: "hidden" }}
    />
  );

  return { executeReCaptcha, ReCaptchaComponent };
};